var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCleanupHddIcon = function SvgCleanupHddIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11,
    fill: "none",
    viewBox: "0 0 16 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M15.875 7.063a1.33 1.33 0 0 0-1.312-1.313H1.438c-.739 0-1.313.602-1.313 1.313v2.625C.125 10.426.699 11 1.438 11h13.125c.71 0 1.312-.574 1.312-1.312zm-1.312-2.188c.218 0 .601.082.82.191l-2.625-3.964C12.539.773 12.047.5 11.664.5H4.31c-.383 0-.875.273-1.094.602L.59 5.066a2.2 2.2 0 0 1 .82-.191h13.153M13.25 7.5a.9.9 0 0 1 .875.875c0 .492-.41.875-.875.875a.864.864 0 0 1-.875-.875c0-.465.383-.875.875-.875m-2.625 0a.9.9 0 0 1 .875.875c0 .492-.41.875-.875.875a.864.864 0 0 1-.875-.875c0-.465.383-.875.875-.875"
  })));
};
export default SvgCleanupHddIcon;